import { render, staticRenderFns } from "./BoxLoading.vue?vue&type=template&id=11411ad2"
import script from "./BoxLoading.vue?vue&type=script&lang=js"
export * from "./BoxLoading.vue?vue&type=script&lang=js"
import style0 from "./BoxLoading.vue?vue&type=style&index=0&id=11411ad2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports